// src/pages/Dashboard.jsx
import React, { useState, useEffect } from 'react';
import { Layout } from '../components/Layout/Layout';
import { MapComponent } from '../components/MapComponent';
import { DriverProfileCard } from '../components/DriverProfileCard';
import { StatsCard } from '../components/StatsCard';
import { IncomeTracker } from '../components/IncomeTracker';
import { TripsList } from '../components/TripsList';
import { useSelector } from 'react-redux';

export default function Dashboard() {

  const passengers = useSelector(state => state.dashboard.totals.passengers);
  const trips      = useSelector(state => state.dashboard.totals.trips);
  const [vehicles, setVehicles] = useState([]);
  useEffect(() => {
    fetchVehiclePositions().then(setVehicles);
    const id = setInterval(() => fetchVehiclePositions().then(setVehicles), 5000);
    return () => clearInterval(id);
  }, []);

  return (
    <Layout>
      {/* full-width map */}
      <div className="w-full h-64 md:h-150 p-4 lg:p-6 mb-4">
        <h2 className="text-xl md:text-2xl font-semibold mb-2 text-text-primary dark:text-text-primary-dark">
          Live Vehicle Tracking
        </h2>
        <div className="w-full h-full z-1">
          <MapComponent vehicles={vehicles} />
        </div>
      </div>

      {/* widgets grid */}
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 p-4 lg:p-6">
        <div className="lg:col-span-8 space-y-6">
          <DriverProfileCard />
           <div className="sm:col-span-2 lg:col-span-8 grid grid-cols-1 md:grid-cols-2 gap-6">
          <StatsCard
            title="Total Passengers"
            value={passengers?.value}
            change={passengers?.change}
            data={passengers?.data}
            color="green"
          />
          <StatsCard
            title="Total Trips"
            value={trips?.value}
            change={trips?.change}
            data={trips?.data}
            color="red"
          />
        </div>
          <IncomeTracker />
        </div>
        <aside className="lg:col-span-4">
          <TripsList />
        </aside>
      </div>
    </Layout>
  );
}

// replace this with your real data source
async function fetchVehiclePositions() {
  return [
    { id: 1, coords: [9.9312, 76.2673], label: 'Cab #1' },
    { id: 2, coords: [9.9350, 76.2700], label: 'Cab #2' },
    { id: 3, coords: [9.9280, 76.2630], label: 'Cab #3' },
  ];
}
